import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import Footer from '@/components/organisms/Footer/Footer';
import Header from '@/components/organisms/Header/Header';
import { Blocks } from '@/components/organisms/Blocks/Blocks';
const FullWidthPage = (props) => {
    console.log(props); // TODO
    return (_jsxs(_Fragment, { children: [_jsx(Header, { ...props.header }), _jsx("div", { "data-epi-edit": "MainRegion", children: _jsx(Blocks, { blocks: props.mainRegion }) }), _jsx(Footer, { ...props.footer })] }));
};
export default FullWidthPage;
